<template>
    <button
        class="rounded-sm focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-brand-300 focus:outline-none focus-visible:outline-none"
    >
        <slot></slot>
    </button>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
    name: 'IconButton',
})
</script>
